/**
 * Wingman Firebase App Config
 * Initialised with live credentials from .env
 */
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

// Prevent duplicate initialization (important for Vite HMR)
export const firebaseApp = getApps().length === 0
    ? initializeApp(firebaseConfig)
    : getApp();

// Analytics (browser-only)
export const analytics = typeof window !== 'undefined'
    ? getAnalytics(firebaseApp)
    : null;
